/**
 * 转换类似 1335-2-JR_62301冰箱,1725-2-运输模式这样的监测点
 * [0]为监测点id [1]为监测点类型 [2]为监测点名
 */
export const transformMultiCarrier = carrierListStr => {
  const carrierList = carrierListStr.split(',')
  return carrierList.map(item => {
    return transformSingleCarrier(item)
  })
}

// 转换单个carrier
const transformSingleCarrier = carrierStr => {
  const carrierArr = carrierStr.split('-')
  return {
    id: carrierArr[0],
    type: carrierArr[1],
    name: carrierArr[2]
  }
}
